import * as ActionTypes from "constants/ActionTypes";
import { combineReducers } from "redux";

function chapterListVisible(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_SLIDESHOW_INFO_TOGGLE:
    case ActionTypes.SET_SLIDESHOW_GALLERY_TOGGLE:
    case ActionTypes.SET_STORY_INFO_VISIBLE:
      return state && !action.visible;
    case ActionTypes.SET_CHAPTER_LIST_VISIBLE:
      return action.visible;
    default:
      return state;
  }
}

function slideshowGalleryToggle(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_SLIDESHOW_INFO_TOGGLE:
      return state && !action.visible;
    case ActionTypes.SET_SLIDESHOW_GALLERY_TOGGLE:
      return action.visible;
    default:
      return state;
  }
}

function slideshowInfoToggle(state = false, action) {
  switch (action.type) {
    case ActionTypes.SET_SLIDESHOW_INFO_TOGGLE:
      return action.visible;
    case ActionTypes.SET_SLIDESHOW_GALLERY_TOGGLE:
      return state && !action.visible;
    default:
      return state;
  }
}

export default combineReducers({
  chapterListVisible,
  slideshowGalleryToggle,
  slideshowInfoToggle,
});
